import React from 'react'
import { graphql } from 'gatsby'
import Seo from '../../components/seo'
import get from 'lodash/get'
import Layout from '../../components/layout'
import { videoMetadata, canonicalUrl } from '../../utils/seo'
import ShareSocial from '../../components/share-social'
import BrandedMedia from '../../components/branded-media'
import styles from './index.module.css'
import { Grid, Typography, Button } from '@material-ui/core'

class Video extends React.Component {
  render() {
    const video = get(this.props, 'data.contentfulVideo')
    const categorie = get(this.props, 'data.contentfulVideo.categorie')
    const siteTitle = video.titolo

    const seoPath = `/video/${this.props.pageContext.slug}/`
    const metadata = videoMetadata(video.contenuto, video.titolo)

    return (
      <Layout location={this.props.location}>
        <Seo title={metadata.title} description={metadata.description} path={seoPath} noIndex={video.titolo === 'NON ELIMINARE'} />
        <div className={styles.container}>
          <div className={styles.gridContainer}>
            <Grid container spacing={0}>
              <Grid item xs={12} className={styles.titleContainer}>
                {video.categorie.map((categoria) => (
                  <Typography variant={'h3'} className={styles.labelCategorie}>
                    {categoria.label}
                  </Typography>
                ))}
              </Grid>
              <Grid item lg={12}>
                <BrandedMedia
                  className={styles.embed}
                  html={video.embed.embed}
                  brandingKey={video.slug}
                />
                <div className={styles.content}>
                  <Typography variant={'h3'} component="h1">{video.titolo}</Typography>
                  <Typography variant={'subtitle1'} className={styles.author}>
                    {video.autore &&
                      `${video.autore.nome} ${video.autore.cognome}, ${video.dataPubblicazione}`}
                  </Typography>
                  <div
                    className={styles.text}
                    dangerouslySetInnerHTML={{
                      __html: video.contenuto.childMarkdownRemark.html,
                    }}
                  />
                  <ShareSocial
                    link={canonicalUrl(seoPath)}
                    title={siteTitle}
                  />
                  <div className={styles.buttonsContainer}>
                    {video.categorie.map((categoria) => (
                      <Button
                        className={styles.buttonCategoria}
                        href={`/${categoria.slug}/1/`}
                      >
                        {categoria.label}: Tutti gli articoli
                      </Button>
                    ))}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Layout>
    )
  }
}

export default Video

export const pageQuery = graphql`
  query VideoBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulVideo(slug: { eq: $slug }) {
      id
      slug
      titolo
      contenuto {
        childMarkdownRemark {
          html
        }
      }
      categorie {
        id
        label
        slug
      }
      autore {
        cognome
        nome
        descrizione
      }
      publishedAt: dataPubblicazione
      dataPubblicazione(formatString: "D MMMM YYYY", locale: "it")
      embed {
        embed
      }
    }
  }
`

